import React from 'react';
import './App.css';
import {Route, Switch} from "react-router-dom";
import Auth from "./Auth";
import Home from "./Home";
import Retail from "./retail.js";
import Pincode from "./Pincode";
import TSD from "./tsd";

function App() {
    return (
        <div>
            <Switch>
                <Route path="/auth">
                    <Auth/>
                </Route>
                <Route exact path="/">
                    <Home/>
                </Route>
                <Route path="/pin">
                    <Pincode/>
                </Route>
                <Route path="/tsd">
                    <TSD/>
                </Route>
                <Route path="/retail">
                    <Retail/>
                </Route>
            </Switch>
        </div>
    );
}

export default App;
